import { c as _c } from "react/compiler-runtime";
import { HotelUpdateSearchModalType } from "@website/accommodation-ui/hotel-update-search-modal/hotel-update-search-modal.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { FC } from "react";
export const HotelUpdateSearchModal: FC<HotelUpdateSearchModalType> = properties => {
  const $ = _c(12);
  const {
    onUpdateResult,
    isOpen,
    msg,
    isLoading
  } = properties;
  const message = msg || (process.env.NEXT_PUBLIC_APP_NAME === "villa" ? "\u0642\u06CC\u0645\u062A \u0648 \u0638\u0631\u0641\u06CC\u062A \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627 \u062F\u0627\u0626\u0645\u0627 \u062F\u0631 \u062D\u0627\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0647\u0633\u062A\u0646\u062F. \u0628\u0631\u0627\u06CC \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0627\u0632 \u0622\u062E\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A \u0648 \u0648\u0636\u0639\u06CC\u062A \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u060C \u0644\u0637\u0641\u0627 \u062C\u0633\u062A\u062C\u0648 \u0631\u0627 \u0628\u0631\u0648\u0632\u200C\u0631\u0633\u0627\u0646\u06CC \u0646\u0645\u0627\u06CC\u06CC\u062F." : "\u0642\u06CC\u0645\u062A \u0648 \u0638\u0631\u0641\u06CC\u062A \u0647\u062A\u0644\u200C\u0647\u0627 \u062F\u0627\u0626\u0645\u0627 \u062F\u0631 \u062D\u0627\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0647\u0633\u062A\u0646\u062F. \u0628\u0631\u0627\u06CC \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0627\u0632 \u0622\u062E\u0631\u06CC\u0646 \u0642\u06CC\u0645\u062A \u0648 \u0648\u0636\u0639\u06CC\u062A \u0647\u062A\u0644\u200C\u0647\u0627\u060C \u0644\u0637\u0641\u0627 \u062C\u0633\u062A\u062C\u0648 \u0631\u0627 \u0628\u0631\u0648\u0632\u200C\u0631\u0633\u0627\u0646\u06CC \u0646\u0645\u0627\u06CC\u06CC\u062F.");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex"><MaterialIcon className="text-on-surface-medium-emphasis text-xl" name="history" /><h3 className="text-headline-6 pr-4">بروزرسانی جستجو</h3></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== message) {
    t1 = <div className="text-body-2 text-on-surface-high-emphasis pb-10 pt-6">{message}</div>;
    $[1] = message;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLoading || $[4] !== onUpdateResult) {
    t2 = <Button loading={isLoading} size="large" children={"\u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062C\u0633\u062A\u062C\u0648"} color="secondary" fullWidth={true} onClick={onUpdateResult} />;
    $[3] = isLoading;
    $[4] = onUpdateResult;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="lg:w-[400px]">{t0}{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isOpen || $[10] !== t3) {
    t4 = <Modal open={isOpen} onClose={_temp} showCloseButton={false} mobileHeight="auto" animate="bottom">{t3}</Modal>;
    $[9] = isOpen;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp() {}